const PAYMENT_PROMPT_KEY = 'obc:post-auth-payment-card-prompt'

export function markPaymentPromptPending(user) {
  if (user?.role === 'admin') return

  try {
    sessionStorage.setItem(PAYMENT_PROMPT_KEY, 'pending')
  } catch {
    // Session storage can be unavailable in private or locked-down browsers.
  }
}

export function isPaymentPromptPending() {
  try {
    return sessionStorage.getItem(PAYMENT_PROMPT_KEY) === 'pending'
  } catch {
    return false
  }
}

export function clearPaymentPromptPending() {
  try {
    sessionStorage.removeItem(PAYMENT_PROMPT_KEY)
  } catch {
    // Nothing to clear when session storage is unavailable.
  }
}
